import { render, staticRenderFns } from "./wapFut.vue?vue&type=template&id=3cd48172&scoped=true"
import script from "./wapFut.vue?vue&type=script&lang=js"
export * from "./wapFut.vue?vue&type=script&lang=js"
import style0 from "./wapFut.vue?vue&type=style&index=0&id=3cd48172&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd48172",
  null
  
)

export default component.exports